module.exports = __webpack_public_path__ + "static/media/everyday_helth_img.84cd27fb.svg";